import React from 'react'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
import PartDetailForm from '$components/PartDetailForm'
import Part3dFileUpload from '$components/FileUpload/Part3dFileUpload'
import OrderedServiceResult from './OrderedServiceResult'

const ExpandedRow = React.memo(
  ({ record, updateSelectedPart }) => (
    <>
      <Row gutter={[20, 0]}>
        <Col span={6}>
          <Part3dFileUpload record={record} />
        </Col>
        <Col span={18}>
          <PartDetailForm
            record={record}
            updateSelectedPart={updateSelectedPart}
          />
        </Col>
      </Row>
      <OrderedServiceResult record={record} />
    </>
  ),
  (prevProps, nextProps) => {
    return prevProps.record.id === nextProps.record.id
  },
)

ExpandedRow.displayName = 'ExpandedRow'

ExpandedRow.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  updateSelectedPart: PropTypes.func.isRequired,
}

export default ExpandedRow
